import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminPanelService } from 'projects/app-misc/src/app/modules/admin-panel/data/admin-panel.service';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import { ColumnForEdit } from 'projects/app-misc/src/app/modules/admin-panel/data/column-for-edit';
import { NfsSubscription } from 'projects/app-misc/src/app/modules/admin-panel/data/nfs-sub';
import { NfsSubscriptionType } from 'projects/app-misc/src/app/modules/admin-panel/data/nfs-sub-type';
import { forkJoin } from 'rxjs';
import { UserService } from 'projects/core/src/lib/login/data/user.service';
import { UsersService } from '../../../../users/data/users.service';
import { User } from 'projects/core/src/lib/login/data/user';
import { UserRole } from 'projects/core/src/lib/login/data/user-role';

@Component({
  selector: 'app-nfs-sub-editor',
  templateUrl: './nfs-sub-editor.component.html',
  styleUrls: ['./nfs-sub-editor.component.scss']
})
export class NfsSubEditorComponent implements OnInit {
  condId: number
  headerTitle: string = 'New Subscription';
  footerBtnString: string = 'Add'
  tempNfsSub: NfsSubscription;

  allTypes: NfsSubscriptionType[]
  selectedType: NfsSubscriptionType

  allUsers: User[]
  selectedUser: User

  allRoles: UserRole[]
  selectedRole: UserRole

  loadingSpinner: boolean;
  deleteLoadingSpinner: boolean;

  showSubsOption = false;

  listOfSubs = ['SPECIAL_USER', 'USER_ROLE']

  typeLoading = true;

  constructor(
    protected dialogRef: MatDialogRef<NfsSubEditorComponent>,
    protected adminPanelService: AdminPanelService,
    private userService: UserService,
    private usersService: UsersService,
    private miscSnackBarService: MiscSnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: {
      condId: number,
      nfsSub: NfsSubscription,
    }
  ) {
    this.tempNfsSub = Object.assign({}, this.data.nfsSub);
    this.condId = this.data.condId;

    if(this.tempNfsSub.id) {
      this.headerTitle = 'Edit Subscription'
      this.footerBtnString = 'Save'
    }
  }

  ngOnInit(): void {
    forkJoin(this.userService.getActiveUsers(), this.usersService.getRoles(), this.adminPanelService.getConditionSubTypes()).subscribe((res => {
      let users = res[0]
      let roles = res[1]
      let types = res[2]

      this.fillUsers(users)
      this.fillRoles(roles)
      this.fillTypes(types)

      this.typeLoading = false;
    }))
  }

  saveSub() {
    this.loadingSpinner = true;

    this.tempNfsSub.type = this.selectedType.value

    if(this.selectedType.value === 'SPECIAL_USER') {
      this.tempNfsSub.user = this.selectedUser
    } else if(this.selectedType.value === 'USER_ROLE') {
      this.tempNfsSub.roleName = this.selectedRole.name
    }
    if(this.tempNfsSub.id) {
      this.adminPanelService.saveConditionSub(this.condId, this.tempNfsSub).subscribe(res => {
        this.dialogRef.close(res)
      }, error => {
        this.loadingSpinner = false
      })
    } else {
      this.adminPanelService.addConditionSub(this.condId, this.tempNfsSub).subscribe(res => {
        this.dialogRef.close(res)
      }, error => {
        this.loadingSpinner = false
      })
    }
  }

  fillRoles(roles) {
    this.allRoles = roles
    this.selectedRole = this.allRoles.find(role => role.name === this.tempNfsSub.roleName)
  }

  fillUsers(users) {
    this.allUsers = users
    this.selectedUser = this.allUsers.find(user => user.id === this.tempNfsSub.user?.id)
  }

  fillTypes(types) {
    this.allTypes = types;
    this.selectedType = this.allTypes.find(type => type.value === this.tempNfsSub.type)
    if(this.selectedType) {
      this.showSubsOption = this.listOfSubs.includes(this.selectedType.value)
    }
    this.typeLoading = false;

  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }

  deleteSub() {
    this.deleteLoadingSpinner = true
    this.adminPanelService.deleteConditionSub(this.condId, this.tempNfsSub.id).subscribe(emit => {

      this.dialogRef.close('delete');
    }, error => {
      this.deleteLoadingSpinner = false
    })
  }

  subTypeChanged() {
    this.showSubsOption = this.listOfSubs.includes(this.selectedType.value)
  }
}
